import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fmDataContext } from "../../Context/FmData";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { fmTrackDemosContext } from "../../Context/TrackDemosContext";
import userCan from "../../helpers/userCan";
import Swal from "sweetalert2/dist/sweetalert2.all.min";
import "@sweetalert2/theme-dark/dark.min.css";
import jwtDecode from "jwt-decode";
import styles from "./TrackDemoDetails.module.scss";
import { authenticationContext } from "../../Context/AuthContext";

const TrackDemoDetails = () => {
  let [mounted, setMounted] = useState(false);

  let { trackDemoId } = useParams();

  let { baseUrl, navigate, showData, editItemExistence, globalCrumbs, setGlobalCrumbs } = useContext(fmDataContext);
  let { user } = useContext(authenticationContext);

  let [currentTrackDemo, setCurrentTrackDemo] = useState({});

  let [isCurrentTrackDemoLoading, setIsCurrentTrackDemoLoading] = useState(true);

  let [isForceDeleteLoading, setIsForceDeleteLoading] = useState(false);

  let { setTrackDemoMsg } = useContext(fmTrackDemosContext);

  let userToken = jwtDecode(localStorage.getItem("userToken")).accessToken;

  const forceDeleteTrackDemo = (reqMethod, pathName, headers, setLoading) => {
    Swal.fire({
      title: "Are you sure?",
      html: `<p class="mb-0">You will delete <span class="fu-text-light-gray">${currentTrackDemo.data.artist_name}</span> track demo permanently</p><p class="mb-0">You won't be able to revert this!</p>`,
      icon: "warning",
      showCancelButton: true,
      customClass: {
        cancelButton: "popup-btn",
        confirmButton: "popup-btn",
      },
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (userCan("fm_track_demo_force_delete")) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setTrackDemoMsg(`${currentTrackDemo.data.artist_name} Track Demo Deleted Permanently Successfully`);
              navigate("/fm-track-demos");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        } else {
          navigate("/not-found");
        }
      }
    });
  };

  const getTrackDemo = (reqMethod, pathName, setLoading = setIsCurrentTrackDemoLoading, headers) => {
    showData(reqMethod, pathName, setLoading, headers)
      .then((response) => {
        setCurrentTrackDemo(response.data);
        setLoading(false);
      })
      .catch((error) => {
        navigate("/not-found");
      });
  };

  useEffect(() => {
    getTrackDemo("GET", `${baseUrl}fm-track-demo/${trackDemoId}`, setIsCurrentTrackDemoLoading, {
      Accept: "application/json",
      "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
      Authorization: `Bearer ${userToken}`,
    });
    setMounted(true);
  }, []);

  useEffect(() => {
    getTrackDemo("GET", `${baseUrl}fm-track-demo/${trackDemoId}`, setIsCurrentTrackDemoLoading, {
      Accept: "application/json",
      "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
      Authorization: `Bearer ${userToken}`,
    });
    setMounted(true);
  }, [trackDemoId]);

  useEffect(() => {
    if (mounted && currentTrackDemo.data) {
      let globalCrumbsUpdated = globalCrumbs.map((crumb) => {
        if (crumb.name === trackDemoId.toUpperCase()) {
          crumb.name = `${currentTrackDemo.data.artist_name.toUpperCase()} DEMO`;
        }
        return crumb;
      });
      setGlobalCrumbs(globalCrumbsUpdated);
    }
  }, [currentTrackDemo]);

  return (
    <>
      {!isCurrentTrackDemoLoading ? (
        <>
          <div className="container">
            <h1 className="fu-text-2-rem fu-text-1-8-rem-xs fu-text-18-px-xxs fu-text-16-px-xxs fu-fw-800 fu-text-white mb-3 mt-3">{currentTrackDemo.data.artist_name} DEMO</h1>
            <div className="py-1 py-md-2 mt-2 mt-md-3">
              <div className="d-flex align-items-center mb-3 mb-md-4">
                {currentTrackDemo.data.demo_url ? (
                  <div className="me-2">
                    <a className="btn fu-btn-sm fu-btn-gray" href={currentTrackDemo.data.demo_url} target="_blank" rel="noreferrer">
                      <span className="btn-bg"></span>
                      Go To Demo
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {userCan("fm_track_demo_force_delete") ? (
                  <div>
                    <button
                      className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading ? "disabled" : ""}`}
                      onClick={() =>
                        forceDeleteTrackDemo(
                          "DELETE",
                          `${baseUrl}fm-track-demos/force-delete/${currentTrackDemo.data.key}`,
                          {
                            Accept: "application/json",
                            "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                            Authorization: `Bearer ${user.accessToken}`,
                          },
                          setIsForceDeleteLoading
                        )
                      }
                      disabled={isForceDeleteLoading ? true : false}>
                      <span className="btn-bg"></span>
                      Delete
                    </button>
                  </div>
                ) : (
                  ""
                )}

                {isForceDeleteLoading ? (
                  <div className="position-relative ms-4">
                    <LoadingCircle circleCont={35} icon={30} loader={35} dot={35} />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="demos-tags">
                <div className="mb-4 info-tags-container justify-content-start">
                  {currentTrackDemo.data._id ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#ID: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentTrackDemo.data._id}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentTrackDemo.data.key ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#KEY: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentTrackDemo.data.key}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {currentTrackDemo.data.sent_at ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">DEMO SENT AT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentTrackDemo.data.sent_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {currentTrackDemo.data.artist_email_address ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">SENDER EMAIL ADDRESS: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentTrackDemo.data.artist_email_address}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* About demo */}
              {currentTrackDemo.data.about_demo !== null ? (
                <div className="mb-2 mb-md-4">
                  <div className="d-flex align-items-center mb-2 mb-md-4">
                    <div className="flex-grow-1 iu-row-heading">
                      <h2 className="mb-0 row-title">ABOUT DEMO</h2>
                    </div>
                  </div>
                  <div>
                    <p className={styles.about_demo} dangerouslySetInnerHTML={{ __html: currentTrackDemo.data.about_demo }} />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
};

export default TrackDemoDetails;
